import {
    observable,
    runInAction,
    action,
    reaction,
    toJS
  } from 'mobx';
  import {ViewBase} from 'mutants-appfx';
  import BatchApi from '../api/BatchApi.js';
  import tools from '../util/tools';
  import common from '../util/common';
  import {filterField} from '../fixedViewInfo'
  import _cloneDeep from 'lodash/cloneDeep';
  import {PosInitData,TStore} from 'tplus-poslogin';
  import {Message} from 'tplus-components-touch'
 import config from '../config'
 const minDate = config.minDate;
  class BatchModal extends ViewBase {
    get type(){
      return 'BatchModal';
    }

    @observable selectVisible = false;
    @observable cancelEnable = true;
    @observable targetIndex=0;

    /* data */
    @observable batchsData;//批次选择
    @observable writeData//写入批号

    /* viewInfo */
    selectBatchView;//template 需要用到的viewinfo，多计量单位与单计量不同
    @observable writeBatchView;
    head;

    retailDetail;
    out;

    constructor(store,name){
      super(store,name)
    }

    @action
    async init({cancelEnable,retailDetail},out){
      this.out=out;
      this.retailDetail=_cloneDeep(retailDetail);
      this.retailDetail['ExpiryDate']=null;
      this.retailDetail['ProductionDate']=null;

      if( !tools.isNull(cancelEnable) ){this.cancelEnable=cancelEnable;}
      this.head=[{
        'Title':'存货名称',
        'Value':retailDetail.Inventory.Name,
      }];

      /* 接口获取批次信息 */
      let RetailDetails=new Array();
      RetailDetails.push(retailDetail);
      const storeInfo = TStore.restore()
      const idStore = storeInfo.storeID
      let result = await BatchApi.getBatchDispatchForRE({ RetailDetails,Idstore:idStore}) ;

      let data=new Array();
      if (result && result.DataSource) {
        data=result.DataSource[0].BatchDispatchDetailDTOs
      }
      let BatchDispatchDetailDTOs=data;

      //可改成接口返回
      this.selectBatchView=this.getSelectBatchView(result.ColumnInfo);
      this.writeBatchView=this.getWriteBatchView();

      //处理接口数据到 view数据（可接口返回）
      let batchsData=this.handleBatchsData(BatchDispatchDetailDTOs);
      runInAction(()=>{
        this.batchsData=batchsData;
        if( this.batchsData.length == 1 ){
          this.targetIndex = 0;
        }
        this.show();
      })
      return;
    }

    //接口数据不符合页面规范，需要整理
    handleBatchsData(BatchDispatchDetailDTOs){
      let data=_cloneDeep(BatchDispatchDetailDTOs)
      data.forEach((el)=>{
        this.selectBatchView.forEach((field)=>{
          let key=field.dataIndex;
          let value=el[key];
          if(key==='Quantity'||key==='Quantity2'){
            if(!el[key])el[key]=0
            return
          }
          el[key] = value;
        })
      })
      return data;
    }

    /* 是否 是称重商品且不允许修改数量 */
    isQuantityLimit=()=>{
      const isBalanceCanChange = PosInitData("isBalanceCanChange");//是否可以手动修改
      const isWeigh = this.retailDetail.Inventory.IsWeigh;
      return !isBalanceCanChange&&isWeigh;
    }

    /* 获取批次选择vm （可改为接口返回）*/
    getSelectBatchView(selectBatch){
      let retailDetail=this.retailDetail;
      const isReturn=common.getIsReturn(this.store.data);
      let isLaborCost= retailDetail.Inventory.IsLaborCost;
      /* 数量column 控制 */
      let quantityColumn=selectBatch.filter(el=>el.dataIndex==='Quantity'||el.dataIndex==='Quantity2');
      let quick=true;
      if(!isLaborCost&&!isReturn){
        quantityColumn.forEach(el=>{
          el.minValue=0;
        })
      }

      if (retailDetail.ReturnSourceDetailId 
        && retailDetail.ReturnSourceDetailId>0) {
          quantityColumn.forEach(el=>{
            el.maxValue=0;
            el.minValue=-999999999999;
          })
      }
      
      if(!common.getIsModifyQuantityAuth()){
        quick=false;
      }
      quantityColumn.forEach(el=>{
        el.quick=quick;
        el.readOnly= false;
      })

      const quantityDecimalDigits=PosInitData("QuantityPrecision");
      selectBatch.forEach((el)=>{
        el.precision=quantityDecimalDigits
      })
      this.handleColumn(selectBatch);
      console.log('selectBatch:',selectBatch)
      return selectBatch;
    }

     //处理列 设置列宽
     handleColumn(columns){
      if(columns && columns.length > 0){
        const fixedCount=1;//固定列数
        let columnWidth=150;
        let tableWidth=740;
        const columnLength = columns.length;

        if(columnLength<=5){
          columnWidth=tableWidth/columnLength
        }else{
          columns.forEach((el,index)=>{
            if(index<fixedCount)el.fixed='left';
          })
        }
        columns.forEach((column)=>{
          column.width = columnWidth
        });
      }
    }

    /* 写入批次vm */
    getWriteBatchView(){
      /* 写入批次模板 */
      let writeBatchView = _cloneDeep(filterField('WriteBatch'));
      //数量的控制
      let quantityField = writeBatchView.find(el => el.FieldName === 'Quantity');

      let selectQuantityField = this.selectBatchView.find(el => el.key === 'Quantity');

      const isReturn = common.getIsReturn(this.store.data);

      let updateProps={};
      if(this.isQuantityLimit()){//数量填入
        updateProps={
          ...updateProps,
          disabled:true,
          Value:this.retailDetail.Quantity
        }
      }
      updateProps = {
        ...updateProps,
        ...common.getInputLimit('quantity'),
        max: { value: tools.isNull(selectQuantityField.maxValue) ? null : selectQuantityField.maxValue },
        min: { value: tools.isNull(selectQuantityField.minValue) ? null : selectQuantityField.minValue },
        isReturn: isReturn
      }
      Object.assign(quantityField,updateProps)
      //没有启用有效期  去除时间选择表单
      if (!this.retailDetail.Inventory.IsQualityPeriod) {
        writeBatchView = writeBatchView.filter((el, index) => {
          if (el.FieldName !== 'ExpiryDate' && el.FieldName !== 'ProductionDate') {
            return true
          }
        })
      }
      //带入默认 生产日期/失效日期
      let detail = this.retailDetail;
      writeBatchView && writeBatchView.forEach((el) => {
        if (el.FieldName == 'ExpiryDate' || el.FieldName == 'ProductionDate') {
          let val = detail[el.FieldName]
          el.Value = val
        }
      })
      return writeBatchView;
    }

    //确定or取消
    @action
    ok=()=>{
      let batchsData=toJS(this.batchsData)
      if(this.isQuantityLimit()){
        let sum=0;
        batchsData.forEach((el)=>sum+=Number(el.Quantity))
        if(sum!=this.retailDetail.Quantity){
          Message.warn('总数量与商品称重数量不一致')
          return
        }
      }
      console.log('批次弹框输出:',batchsData)
      this.out(batchsData)
      this.hide();
    }

    @action
    cancel=async ()=>{
      if(this.cancelEnable){
        await this.hide();
        this.out()
      }
    }

    @action
    show=()=>{
        this.selectVisible=true;
    }

    async hide(){
      await runInAction(()=>{
        this.selectVisible=false;
        this.targetIndex=-1;
      })
    }

    @action
    reset=()=>{
      this.writeBatchView.forEach((el)=>{
        el.Value=""
      })
    }

    @action changeTargetIndex({index=-1}){
      this.targetIndex=index;
    }

   /*  ========================手动录入批次start=================== */
    /* 弹框手动录入批次 */
    batchWrite = async()=>{
      await this.hide();
      let TextBox= this.store.getViewItem('TextBoxModal');
      let formData={
        Title:'批号录入',
        Head:this.head,
        Data:this.writeBatchView,
        check:this.check.bind(this),
        update:this.updateWrite.bind(this)
      }
      const batchInputData = await new Promise((resolve,reject)=>{
          TextBox.inputForm(formData,resolve)
      });
      if(batchInputData){
        runInAction(()=>{
          this.batchsData=[batchInputData]
        });
        this.ok();
      }else{
        this.cancel();
      }
    }
    /* form 数据改变 */
    updateWrite=async ({formData,updateProp})=>{
      var param={};

      param.updateProp=updateProp;
      param.updateRetailDetail=this.retailDetail;

      let updateName=updateProp.name;
      if( updateName!=='ProductionDate'&& updateName!=='ExpiryDate' )return false;
      console.log('批次录入update数据：',param)
      let that=this;
      return this.controllerEvent("updateBatchDetail",param).then(()=>{
        let updateResult={};
        let retailDetail=that.retailDetail;
        const updateFieldName=['ProductionDate','ExpiryDate'];
        updateFieldName.forEach((el)=>{
          if(el in retailDetail){
            updateResult[el]=retailDetail[el];
          }
        })
        return updateResult;
      })  //调用controller方法
    }

    /* 检查数据 return 错误数据 */
    async check(outData) {
      for (let i = 0; i < this.writeBatchView.length; i++) {
        let FieldName = this.writeBatchView[i].FieldName;
        let Title = this.writeBatchView[i].Title;
        if (tools.isNull(outData[FieldName])) {
          return this.error(FieldName, 'error', Title + '为空')
        }
      }
      const isReturn = common.getIsReturn(this.store.data);
      if (!isReturn && (Number(outData.Quantity) < 0)) {
        return this.error('Quantity', 'error', '开单数量不能小于0')
      }
      return null;
    }

    @action
    error=(key,state,errMsg)=>{
      return {
        FieldName:key,
        State:state,
        Label:errMsg
      }
    }

    static fromJS(store, {}) {
      return new BatchModal(store, 'BatchModal')
    }

  }
  export default BatchModal;
